module.exports = __webpack_public_path__ + "static/media/favicon.a3fa8954.png";